export default "__VITE_ASSET__Dk1zrnEP__"